var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelatives(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2914 21.9395C19.6729 21.9395 22.5632 22.4519 22.5632 24.4988C22.5632 26.5457 19.6922 27.0728 16.2914 27.0728C12.9089 27.0728 10.0195 26.565 10.0195 24.5171C10.0195 22.4693 12.8896 21.9395 16.2914 21.9395Z",
    stroke: "#1A1B20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.29 19.0177C14.0699 19.0177 12.2695 17.2183 12.2695 14.9981C12.2695 12.7779 14.0699 10.9785 16.29 10.9785C18.5093 10.9785 20.3096 12.7779 20.3096 14.9981C20.3179 17.21 18.5304 19.0094 16.3184 19.0177H16.29Z",
    stroke: "#1A1B20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6094 17.9739C24.077 17.7676 25.2072 16.5081 25.21 14.9837C25.21 13.4813 24.1145 12.2346 22.6781 11.999",
    stroke: "#1A1B20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5469 21.5039C25.9686 21.7157 26.9614 22.2143 26.9614 23.241C26.9614 23.9477 26.4939 24.4061 25.7385 24.693",
    stroke: "#1A1B20",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatives);
export default __webpack_public_path__ + "static/media/Relatives.1e367ad4ef6f13af51df06f21b88c082.svg";
export { ForwardRef as ReactComponent };